import axios, { AxiosResponse } from 'axios';

import { LoginBackendResponseDTO } from './dto/loginBackendResponseDto';

const authLogoutEndpoint = 'logout';

export const logInToLeadtechBackendWithEmailAndLocalId = (
  baseApiUrl: string,
  loginUrl: string
): Promise<AxiosResponse<LoginBackendResponseDTO>> => {
  return axios.get(`${baseApiUrl}/${loginUrl}`);
};

export interface LoginByEmailAndPassFirebaseRequestDTO {
  email: string;
  password: string;
  returnSecureToken: boolean;
}

export interface FirebaseLoginResponseDTO {
  readonly displayName: string;
  readonly email: string;
  readonly expiresIn: string;
  readonly idToken: string;
  readonly kind: string;
  readonly localId: string;
  readonly refreshToken: string;
  readonly registered: boolean;
}

export const logInToFirebaseWithEmailAndPassword = (
  loginData: LoginByEmailAndPassFirebaseRequestDTO,
  firebaseKey: string
): Promise<AxiosResponse<FirebaseLoginResponseDTO>> => {
  return axios.post<FirebaseLoginResponseDTO>(
    `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=${firebaseKey}`,
    loginData
  );
};

export const logout = async (baseApiUrl: string): Promise<void> => {
  const response: AxiosResponse<void> = await axios.get(`${baseApiUrl}/${authLogoutEndpoint}`);

  return response.data;
};

const authAPI = {
  logInToFirebaseWithEmailAndPassword,
  logInToLeadtechBackendWithEmailAndLocalId,
  logout,
};

export default authAPI;
